import { ArrowLeftIcon } from '@phosphor-icons/react';
import { useNavigate } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import { ThemeContext } from '../../../../apps/frontend/src/context/ThemeStore';
import FeatureCardSecond from './generic/FeatureCardSecond';
import { AppLayout } from '../Layout/AppLayout';
import axios from 'axios';
import { usePackStorage } from '../Layout/usePackStorage';

export default function ExploreQuizrr() {
  const navigate = useNavigate();
  const { isDarkTheme } = useContext(ThemeContext);
  const [videoCards, setVideoCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { purchasedPacks, selectedPack } = usePackStorage();

  const imgBasePath = isDarkTheme ? '/svg-explore-quizrr-dark' : '/svg-explore-quizrr';

  useEffect(() => {
    const fetchVideoCards = async () => {
      try {
        setLoading(true);
        const response = await axios.get('/api/content/explore-quizrr/content');
        console.log('Fetch response:', response);

        const cards = response?.data?.data || [];

        const formattedCards = cards.map((card) => ({
          title: card.title,
          description: card.description,
          duration: card.duration,
          videoUrl: card.videoUrl,
          tag: card.tag,
          iconSrc: isDarkTheme ? card.iconDarkSrc : card.iconSrc,
          condition: true,
          examId: card.examId,
        }));

        setVideoCards(formattedCards);
        console.log('Available video cards:', formattedCards);
      } catch (error) {
        console.error('Error fetching video cards:', error);
        setError('Failed to load content. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchVideoCards();
  }, [isDarkTheme]);

  if (loading) {
    return (
      <AppLayout purchasedPacks={purchasedPacks} selectedPack={selectedPack}>
        <div className="bg-[var(--q3-surface-default)]">
          <main className="mx-auto w-full max-w-6xl px-4 py-6 md:py-10">
            <div className="flex justify-center items-center h-64">
              <p className="text-[var(--q3-neutral-light)]">Loading...</p>
            </div>
          </main>
        </div>
      </AppLayout>
    );
  }

  if (error) {
    return (
      <AppLayout purchasedPacks={purchasedPacks} selectedPack={selectedPack}>
        <div className="bg-[var(--q3-surface-default)]">
          <main className="mx-auto w-full max-w-6xl px-4 py-6 md:py-10">
            <div className="flex justify-center items-center h-64">
              <p className="text-[var(--q3-danger-normal)]">{error}</p>
            </div>
          </main>
        </div>
      </AppLayout>
    );
  }

  return (
    <AppLayout purchasedPacks={purchasedPacks} selectedPack={selectedPack}>
      <div className="bg-[var(--q3-surface-default)]">
        <main className="mx-auto w-full max-w-6xl px-4 py-6 md:py-10 ">
          {/* Header */}
          <header className="mb-6 flex items-center gap-3 relative">
            <button
              onClick={() => navigate(-1)}
              aria-label="Go back"
              className="rounded-full p-2 bg-[var(--q3-surface-dimmer)] cursor-pointer absolute left-0 top-0"
            >
              <ArrowLeftIcon className="h-5 w-5 text-[var(--q3-neutral-default)]" />
            </button>

            <div className="w-full flex justify-center md:justify-start">
              <h1 className="sr-only">Explore & Learn Quizrr</h1>
            </div>
          </header>

          {/* Top Section */}
          <section className="mb-10 flex flex-col items-center gap-6 md:grid md:grid-cols-[1.2fr_0.8fr] md:items-center">
            <div className="order-1 md:order-2 mx-auto w-[146px] h-[146px] md:w-[260px] md:h-[244px] aspect-square md:aspect-auto">
              <img
                src={`${imgBasePath}/svg10.svg`}
                alt="Learning illustration"
                className="w-full h-full object-contain"
              />
            </div>

            <div className="order-2 md:order-1 text-center md:text-left">
              <h2 className="text-balance font-semibold text-[42px] md:text-[56px] leading-[52px] md:leading-[64px] tracking-[-1.176px] text-[var(--q3-neutral-default)]">
                Explore Quizrr
              </h2>

              <p className="mt-3 w-full max-w-[434px] text-[16px] md:text-[18px] leading-[22px] md:leading-[24px] text-[var(--q3-neutral-light)] mx-auto md:mx-0">
                Your go-to section to learn, master, and make the most of Quizrr. Watch step-by-step guides, tips, and
                tutorials to boost your preparation and stay on track.
              </p>
            </div>
          </section>

          {/* Featured Videos */}
          <section aria-labelledby="featured" className="mb-4">
            <h3 className="text-2xl font-bold text-[var(--q3-neutral-default)] text-center md:text-left">
              Featured Videos
            </h3>

            <div
              className="
      mt-6
      grid grid-cols-1 gap-4
      sm:grid-cols-2
      md:[@media(min-width:1024px)]:grid-cols-3
      [@media(min-width:1139px)]:lg:grid-cols-4
    "
            >
              {videoCards.map((card, index) => (
                <FeatureCardSecond
                  key={card._id || index}
                  title={card.title}
                  description={card.description}
                  duration={card.duration}
                  videoUrl={card.videoUrl}
                  tag={card.tag}
                  iconSrc={card.iconSrc}
                />
              ))}
            </div>
          </section>
        </main>
      </div>
    </AppLayout>
  );
}
